module.exports = __webpack_public_path__ + "media/location/videoTours-6fee7aea.jpg";